export function getRem() {
  const rem = window.getComputedStyle(document.documentElement)['fontSize']
  return parseFloat(rem)
}
const $baseFontSize = 75
export function pxToRem($px, $baseSize = $baseFontSize) {
  return ($px / $baseSize) * getRem() + 'px'
}
export function getDpr() {
  return document.documentElement.getAttribute('data-dpr')
}
export function fontDpr($fontSize) {
  let num, unit
  if (typeof $fontSize === 'number') {
    num = $fontSize
    unit = 'px'
  } else {
    num = $fontSize.replace(/[a-z]+/i, '')
    unit = $fontSize.replace(/\d+/, '')
  }
  const scale = getDpr()
  if (scale === '2') {
    return num * 2 + unit
  } else if (scale === '3') {
    return num * 3 + unit
  } else {
    return num + unit
  }
}



// WEBPACK FOOTER //
// ./src/public-resource/libs/cssCompute/index.js